export const columns = [
  {
    key: 'riskName',
    label: 'Risk Name',
    value: 'riskName',
    isSortable: true,
    isChecked: true,
    isPinned: true,
    hasCheckbox: true,
    width: '12.25rem',
  },
  {
    key: 'function',
    label: 'Function',
    value: 'function',
    isSortable: true,
    isChecked: true,
    width: '12.25rem',
  },
  {
    key: 'riskDescription',
    label: 'Risk Description',
    value: 'riskDescription',
    isSortable: true,
    isChecked: true,
    width: '12.25rem',
  },
  {
    key: 'riskScore',
    label: 'Risk Score',
    value: 'riskScore',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'application',
    label: 'Application',
    value: 'application',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'accountName',
    label: 'Account Name',
    value: 'accountName',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'actualVsPotential',
    label: 'Actual vs Potential',
    value: 'actualVsPotential',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'riskType',
    label: 'Risk Type',
    value: 'riskType',
    isSortable: true,
    isChecked: true,
    width: '100%',
    minWidth: '10rem',
  },
  {
    key: 'actionColumn',
    label: 'actionColumn',
    value: 'actionColumn',
    isPinned: true,
    isColumnConfigEnabled: true,
    isChecked: true,
    width: '3rem',
  },
];

export const sortOptions = [
  {
    label: 'Ascending',
    value: 'asc',
    isDisabled: false,
    isChecked: false,
    icon: 'ArrowDown',
    shouldShowCheckIcon: true,
  },
  {
    label: 'Descending',
    value: 'desc',
    isDisabled: false,
    isChecked: false,
    icon: 'ArrowUp',
    shouldShowCheckIcon: true,
  },
];

export const sortConfigs = [
  { key: 'riskName', sortOptions },
  { key: 'function', sortOptions },
  { key: 'riskDescription', sortOptions },
  { key: 'riskScore', sortOptions },
  { key: 'application', sortOptions },
  { key: 'accountName', sortOptions },
  { key: 'actualVsPotential', sortOptions },
  { key: 'riskType', sortOptions },
];

export const REPORT_MODAL_TABS = {
  CURRENT_VIEW: 'currentView',
  TEMPLATES: 'templates',
  MY_REPORT: 'myReport',
};

export const CURRENT_VIEW_TYPES = [
  {
    id: 'summary',
    name: 'radioGroupKinds',
    title: 'User Violations - Summary',
    description: 'Lists each user violation as a single record.',
    value: 'summary',
  },
  {
    id: 'detail',
    name: 'radioGroupKinds',
    title: 'User Violations - Detail',
    description:
      'Expands on the Summary by breaking down each violation into individual assigned entitlements and roles.',
    value: 'detail',
  },
  {
    id: 'permissions',
    name: 'radioGroupKinds',
    title: 'User Violations - Permissions',
    description:
      '(Specific to SAP) Expands on the Detail by including transaction codes and objects that contribute to violations.',
    value: 'permissions',
  },
];

export const TEMPLATES_TYPES = [
  {
    id: 'violationsSummary',
    name: 'radioGroupKinds',
    title: 'User Violations - Summary',
    description: 'Lists each user violation as a single record.',
    value: 'summary',
  },
  {
    id: 'violationsDetail',
    name: 'radioGroupKinds',
    title: 'User Violations - Detail',
    description:
      'Expands on the Summary by breaking down each violation into individual assigned entitlements and roles.',
    value: 'detail',
  },
  {
    id: 'violationsPermissions',
    name: 'radioGroupKinds',
    title: 'User Violations - Permissions',
    description:
      '(Specific to SAP) Expands on the Detail by including transaction codes and objects that contribute to violations.',
    value: 'permissions',
  },
  {
    id: 'entitmentsWithInherentRisks',
    name: 'radioGroupKinds',
    title: 'Entitlements with Inherent Risks',
    description:
      'Lists entitlements with inherent risks, including risk details and user assignments.',
    value: 'entitmentsWithInherentRisks',
  },
  // {
  //   id: 'violationWithMitigatingControls',
  //   name: 'radioGroupKinds',
  //   title: 'Violations with Mitigating Controls Ending in 30 days',
  //   description:
  //     'A list of user violations where the assigned mitigating controls are set to end within the next 30 days.',
  //   value: 'violationWithMitigatingControls',
  // },
];

export const REPORT_TYPE_OPTIONS = [
  {
    label: 'Summary',
    secondaryLabel: 'Lists each user violation as a single record.',
    value: 'summary',
    isDisabled: false,
    isChecked: false,
  },
  {
    label: 'Detail',
    secondaryLabel: 'Includes assigned entitlements and roles.',
    value: 'detail',
    isDisabled: false,
    isChecked: false,
  },
  {
    label: 'Permissions',
    secondaryLabel: 'Includes transaction codes that contribute to violations.',
    value: 'permissions',
    isDisabled: false,
    isChecked: false,
  },
];

// Priority columns for different report types
export const SUMMARY_PRIORITY_COLUMNS = [
  { value: 'riskName', label: 'Risk Name' },
  { value: 'riskDescription', label: 'Risk Description' },
  { value: 'businessProcessNames', label: 'Business Process' },
  { value: 'riskPriority', label: 'Risk Priority' },
  { value: 'riskType', label: 'Risk Type' },
  { value: 'userName', label: 'Username' },
  { value: 'userFirstName', label: 'First Name' },
  { value: 'userLastName', label: 'Last Name' },
  { value: 'functionName', label: 'Function Name' },
  { value: 'actualVsPotential', label: 'Actual vs Potential' },
  { value: 'mitigatingControlNames', label: 'Mitigating Control' },
  { value: 'accountNames', label: 'Account Name' },
  { value: 'assignedEntitlementDisplayNames', label: 'Assigned Entitlement' },
  { value: 'endpointDisplayNames', label: 'Application' },
  { value: 'rulesetName', label: 'Ruleset' },
  { value: 'violationStatus', label: 'Violation Status' },
];

export const DETAIL_PRIORITY_COLUMNS = [
  { value: 'riskName', label: 'Risk Name' },
  { value: 'riskDescription', label: 'Risk Description' },
  { value: 'businessProcessNames', label: 'Business Process' },
  { value: 'riskPriority', label: 'Risk Priority' },
  { value: 'riskType', label: 'Risk Type' },
  { value: 'userName', label: 'Username' },
  { value: 'userFirstName', label: 'First Name' },
  { value: 'userLastName', label: 'Last Name' },
  { value: 'functionName', label: 'Function Name' },
  { value: 'actualVsPotential', label: 'Actual vs Potential' },
  { value: 'mitigatingControlNames', label: 'Mitigating Control' },
  { value: 'accountName', label: 'Account Name' },
  { value: 'assignedEntitlementDisplayName', label: 'Assigned Entitlement' },
  { value: 'violatingEntitlementDisplayNames', label: 'Violating Entitlement' },
  { value: 'accessPath', label: 'Access Path' },
  { value: 'endpointDisplayName', label: 'Application' },
  { value: 'rulesetName', label: 'Ruleset' },
  { value: 'violationStatus', label: 'Violation Status' },
];

export const PERMISSIONS_PRIORITY_COLUMNS = [
  { value: 'riskName', label: 'Risk Name' },
  { value: 'riskDescription', label: 'Risk Description' },
  { value: 'businessProcessNames', label: 'Business Process' },
  { value: 'riskPriority', label: 'Risk Priority' },
  { value: 'riskType', label: 'Risk Type' },
  { value: 'userName', label: 'Username' },
  { value: 'userFirstName', label: 'First Name' },
  { value: 'userLastName', label: 'Last Name' },
  { value: 'functionName', label: 'Function Name' },
  { value: 'actualVsPotential', label: 'Actual vs Potential' },
  { value: 'mitigatingControlNames', label: 'Mitigating Control' },
  { value: 'accountName', label: 'Account Name' },
  { value: 'assignedEntitlementDisplayName', label: 'Assigned Entitlement' },
  { value: 'violatingEntitlementDisplayName', label: 'Violating Entitlement' },
  { value: 'functionEntitlementDisplayName', label: 'Function Entitlement' },
  { value: 'violatingObjectName', label: 'Violating Object Name' },
  { value: 'violatingFieldName', label: 'Violating Field Name' },
  { value: 'violatingFieldValue', label: 'Violating Field Value' },
  { value: 'accessPath', label: 'Access Path' },
  { value: 'endpointDisplayName', label: 'Application' },
  { value: 'rulesetName', label: 'Ruleset' },
  { value: 'violationStatus', label: 'Violation Status' },
];

// Helper function to sort columns by priority
export const sortColumnsByPriority = (
  columnsList: { value: string; label: string; isChecked: boolean }[],
  priorityColumns: { value: string; label: string }[]
) => {
  const priorityMap = new Map(
    priorityColumns.map((col, index) => [col.value, index])
  );

  return [...columnsList].sort((a, b) => {
    const aPriority = priorityMap.get(a.value) ?? 999;
    const bPriority = priorityMap.get(b.value) ?? 999;

    return aPriority - bPriority;
  });
};
